// extracted by mini-css-extract-plugin
export default {"resetButton":"GOkcohU","userBadgeInline":"Pp_NNMA"};